import React from 'react';
import Wrapper from '../assets/wrappers/Info';

const Info = ({ icon, text, link }) => {
  return (
    <Wrapper>
      <span className='icon'>{icon} </span>
      {!link && <span className='text'>{text} </span>}
      {link && (
        <a className='text' href={link}>
          {text}
        </a>
      )}
    </Wrapper>
  );
};
export default Info;
